import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "w-full flex flex-grow flex-col bg-pxblue px-4 pt-4 pb-1 lg:px-16 lg:pt-16 lg:pb-4" }
const _hoisted_2 = { class: "flex flex-row md:flex-nowrap flex-wrap pt-4 md:pt-8 w-full" }
const _hoisted_3 = { class: "md:pr-4 flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "img/eu.logo.png",
  alt: "EU Flag",
  class: "h-12 align-top mr-2 w-auto"
}, null, -1)
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "flex md:flex-row items-center md:ml-auto w-full md:w-auto flex-nowrap pt-2 md:pt-0 pb-2 md:pb-0" }
const _hoisted_7 = { class: "inline-flex flex-grow justify-end" }
const _hoisted_8 = { class: "p-2 h-10 ml-2 border rounded whitespace-nowrap hidden sm:inline-flex" }
const _hoisted_9 = { class: "flex flex-row items-center justify-items-center" }
const _hoisted_10 = {
  key: 0,
  class: "inline-flex items-middle h-10 ml-2 p-2 border rounded"
}
const _hoisted_11 = {
  key: 0,
  class: "text-center relative"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_select = _resolveComponent("vue-select")!
  const _component_country_flag = _resolveComponent("country-flag")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["w-full flex flex-grow px-4 py-3 lg:px-12 lg:py-10", _ctx.className]),
    shallowRef: "wrapper"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["flex-grow", _ctx.wrapperClasses])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("p", {
            innerHTML: _ctx.$t('eu-footer'),
            class: "text-gray-400 text-xxs inline flex-grow text-justify"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_vue_select, {
              options: _ctx.screensOptions,
              "value-by": "code",
              "label-by": "label",
              "model-value": _ctx.selectedPage,
              onSelected: _ctx.goTo,
              class: "screens-options"
            }, null, 8, ["options", "model-value", "onSelected"])
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.screenIndex) + " / " + _toDisplayString(_ctx.screensOptions.length), 1),
          _createVNode(_component_vue_select, {
            options: _ctx.$root.$i18n.availableLocales,
            "model-value": _ctx.$root.$i18n.locale,
            onSelected: _ctx.selectLocale,
            class: "locale-options ml-2"
          }, {
            "dropdown-item": _withCtx(({option}) => [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_country_flag, {
                  country: _ctx.localeCountries[option],
                  size: "normal",
                  class: "no-margin-flag"
                }, null, 8, ["country"]),
                _createTextVNode("   " + _toDisplayString(_ctx.locales[option] || option), 1)
              ])
            ]),
            label: _withCtx((options) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options, (option) => {
                return (_openBlock(), _createBlock(_component_country_flag, {
                  key: option,
                  country: _ctx.localeCountries[option],
                  size: "normal",
                  class: "no-margin-flag"
                }, null, 8, ["country"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["options", "model-value", "onSelected"]),
          (_ctx.$root.sound)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_ctx.$root.audioOn)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: "img/voice_off.svg",
                      class: "h-6 align-center cursor-pointer",
                      alt: "Audio off",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$root.togglePlay(false)))
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.$root.audioOn)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: "img/voice_on.svg",
                      class: "h-6 align-center cursor-pointer",
                      alt: "Audio on",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$root.togglePlay(true)))
                    }))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.isSelectedPage && !_ctx.hideArrow && _ctx.scrolledToBottom !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("img", {
              src: "img/arrow.icon.svg",
              alt: "next page",
              class: "next-arrow2",
              style: _normalizeStyle({marginBottom: (_ctx.scrolledToBottom === true ? '110px': '10px')}),
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.arrowClick && _ctx.arrowClick(...args)))
            }, null, 4)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}